import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

export type JobOrderApplicationFragmentFragment = {
  __typename?: 'JobOrderApplicationHubType';
  applicationId: string;
  jobOrderId: string;
  publicOfferId?: string | null;
  createdAt: string;
  meetingDates: Array<string>;
  ciDate?: string | null;
  cqDate?: string | null;
  status: Types.JobOrderApplicationStatusEnum;
  processStatus: Types.JobOrderApplicationProcessStatusEnum;
  prevProcessStatus?: Types.JobOrderApplicationProcessStatusEnum | null;
  meetingUrl?: string | null;
  isViewedByExpert: boolean;
  handlerId?: string | null;
  preppingId?: string | null;
  flow?: Types.JobOrderApplicationFlowEnum | null;
  contactByPhone?: boolean | null;
  isPreferencesFinished: boolean;
  hasActiveAirInterviewInvitation: boolean;
  preferences?: {
    __typename?: 'JobOrderApplicationPreferencesType';
    location?: string | null;
    workType?: Types.WorkModeEnum | null;
    rateDesired?: number | null;
    linkedInUrl?: string | null;
    availability?: Types.ExpertAvailabilityEnum | null;
    noticeLength?: number | null;
    experienceYears?: number | null;
    englishLevel?: Types.LanguageLevelEnum | null;
    skillsMustHave?: Array<{
      __typename?: 'PreferencesSkillType';
      tagId: string;
      weight: number;
    }> | null;
    skillsNiceToHave?: Array<{
      __typename?: 'PreferencesSkillType';
      tagId: string;
      weight: number;
    }> | null;
  } | null;
};

export const JobOrderApplicationFragmentFragmentDoc = gql`
  fragment JobOrderApplicationFragment on JobOrderApplicationHubType {
    applicationId
    jobOrderId
    publicOfferId
    createdAt
    meetingDates
    ciDate
    cqDate
    status
    processStatus
    prevProcessStatus
    meetingUrl
    isViewedByExpert
    handlerId
    preppingId
    flow
    contactByPhone
    isPreferencesFinished
    hasActiveAirInterviewInvitation
    preferences {
      location
      workType
      rateDesired
      linkedInUrl
      availability
      noticeLength
      experienceYears
      englishLevel
      skillsMustHave {
        tagId
        weight
      }
      skillsNiceToHave {
        tagId
        weight
      }
    }
  }
`;
